import React, { Component } from 'react'
import styled from 'styled-components'

const ImageElt = styled.img`
  display: block;
  width: 100%;
  margin: 1.5rem 0;
  max-height: 70vh;
  object-fit: cover;
  object-position: center top;
  border-radius: 10px;
  border: 1px solid var(--light-gray);
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

export default class BigImage extends Component {
  render() {
    const { src } = this.props
    return <ImageElt alt="" src={src} />
  }
}



// WEBPACK FOOTER //
// ./src/components/BigImage.js